module.exports = __webpack_public_path__ + "img/0.2f439602.png";